import { Injector } from '@angular/core';
import { AppComponentBase } from './app-component-base';
import { BsModalRef } from 'ngx-bootstrap/modal';

export abstract class AppDialogComponentBase extends AppComponentBase {
  bsModalRef: BsModalRef

  title: string = '';
  modalId: string = '';

  minimizedClass: string = 'minimized';
  maximizedClass: string = 'fullscreen';

  constructor(injector: Injector) {
    super(injector);
    this.bsModalRef = injector.get(BsModalRef);
  }

  onCloseModal() {
    this.bsModalRef.hide();
    setTimeout(() => {
      this.toggleModalBackdrop(false);
    }, 500);
  }

  maximizeRestore(maximize: boolean) {
    if(maximize) {
      this.removeCssClass(this.minimizedClass);
      this.addCssClass(this.maximizedClass);
    } else {
      this.removeCssClass(this.maximizedClass);
    }
  }

  minimizeRestore(minimize: boolean) {
    if(minimize) {
      this.removeCssClass(this.maximizedClass);
      this.addCssClass(this.minimizedClass);
      this.toggleModalBackdrop(false);
      this.toggleModalMinimization(true);
    } else {
      this.removeCssClass(this.minimizedClass);
      this.toggleModalBackdrop(true);
      this.toggleModalMinimization(false);
    }
  }

  toggleModalBackdrop(show: boolean) {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      if(show) {
        backdrop.classList.remove('d-none');
        backdrop.classList.add('show');
      } else {
        backdrop.classList.remove('show');
        backdrop.classList.add('d-none');
      }
    }
  }

  toggleModalMinimization(minimize: boolean) {
    const modalElement = this.bsModalRef.content.elementRef.nativeElement.closest('.modal');
    if(!modalElement) { return; }

    if(minimize) {
      modalElement.classList.add('minimized');
    } else {
      modalElement.classList.remove('minimized');
    }
  }

  addCssClass(cssClass: string) {
    const modalElement = this.bsModalRef.content.elementRef.nativeElement.closest('.modal-dialog');
    if(!modalElement) { return; }

    modalElement.classList.add(cssClass);
  }

  removeCssClass(cssClass: string) {
    const modalElement = this.bsModalRef.content.elementRef.nativeElement.closest('.modal-dialog');
    if(!modalElement) { return; }

    modalElement.classList.remove(cssClass);
  }
}
